import httpClient, { paramsToString } from '@/services/http/httpClient'

export const apiGetPdfMaterial = sinisterId => {
  const params = new URLSearchParams()
  params.append('sinister_id', sinisterId)
  return httpClient.get(`pdf/material${paramsToString(params)}`)
    .then(data => data)
}

export const apiGetUpptecPdf = sinisterId => {
  const params = new URLSearchParams()
  params.append('sinister_id', sinisterId)
  return httpClient.get(`pdf/damages/upptec${paramsToString(params)}`)
    .then(data => data)
}

export const apiGetConfirmEmail = ({ sinisterId }) => {
  const params = new URLSearchParams()
  return httpClient.get(`/damages/${sinisterId}/confirm${paramsToString(params)}`)
}
